{
  "API_URL": "https://api.ansvarsakerhet.se",
  "AUTH0_AUDIENCE": "https://ansvar-sakerhet.production.com",
  "AUTH0_DOMAIN": "ansvarsakerhet-production.eu.auth0.com",
  "AUTH0_CLIENT_ID": "eMss2Mh9XDtiIMlouib7e3lhvbu2c6Li",
  "ENABLE_PERSONDATA_REPORT_TEXT_GENERATION": true
}
